import { store } from '@/store'

export default {
  //добавление склада
  stocks_poststocks(data, vue) {
    if (typeof store.state.stock.stocks != 'undefined') {
      vue.$root.$emit('refresh-table', 'stocks')
    }
  },

  //обновление склада
  stocks_putstocks(data) {
    if (typeof store.state.stock.stocks != 'undefined') {
      store.state.stock.stocks.forEach((stock, index) => {
        if (stock.id == data.data.id) store.commit('setStateObject', ['stock.stocks.' + index, data.data])
      })
    }
  },

  //удаление склада
  stocks_deletestocks(data, vue) {
    if (typeof store.state.stock.stocks != 'undefined') {
      vue.$root.$emit('refresh-table', 'stocks')
    }
  },

  //Добавление пользователя к складу
  stocks_putusertostock(data) {
    let entity = store.state.stock.stock;
    if (entity && entity.id === data.data.stock.id) {
      if (typeof entity.responsibles === 'object') {
        store.commit('addStateObject', ['stock.stock.responsibles', data.data.user]);
      }
    }
  },

  //Удаление пользователя из склада
  stocks_deleteuserfromstock(data) {
    let entity = store.state.stock.stock;
    if (entity && entity.id === data.data.stock.id) {
      if (typeof entity.responsibles === 'object') {
        entity.responsibles.forEach((responsible, index) => {
          if (responsible.id == data.data.user.id) {
            store.commit('deleteStateObject', ['stock.stock.responsibles', index, data.data.user])
          }
        });
      }
    }
  },

  //удаление трекинга
  deals_deletetracking(data, vue) {
    vue.$root.$emit('refresh-table', 'freights');
  },

  //изменение статуса отслеживания груза
  deals_puttrackingstatus(data) {
    if (typeof store.state.stock.stocks != 'undefined') {
      store.state.stock.freight_statuses.forEach((status, index) => {
        if (status.id == data.data.id) {
          store.commit('setStateObject', ['stock.freight_statuses.' + index, data.data]);
        }
      })
    }
  },

  //удаление статуса отслеживания груза
  deals_deletetrackingstatus(data, vue) {
    vue.$root.$emit('refresh-table', 'tracking-statuses');
  }

}



// WEBPACK FOOTER //
// ./src/modules/stock/pusher.js